(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-in-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('r7-restock-form')) {
  customElements.define('r7-restock-form', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.initialized) return;
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.initialized = true;
        this.button = this.form.querySelector('button[type="submit"]');
        this.statusWrapper = this.querySelector('[data-restock-status]');
        this.status = this.statusWrapper.firstElementChild;
        this.button.disabled = false;
        this.form.addEventListener('submit', this.submit.bind(this));
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async post(path, data) {
      const response = await fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(this.dataset.companyId), {
        method: 'POST',
        headers: { 'Accept': 'application/vnd.api+json', 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
        body: JSON.stringify({ data }),
        credentials: 'omit',
        signal: this.controller.signal
      });
      if (!response.ok) throw new Error(path + ' returned HTTP ' + response.status);
    }

    showStatus(success) {
      this.statusWrapper.hidden = false;
      this.status.classList.add('alert');
      this.status.classList.toggle('alert--success', success);
      this.status.classList.toggle('alert--error', !success);
      this.status.setAttribute('role', success ? 'status' : 'alert');
      this.status.textContent = success ? this.dataset.success : this.dataset.error;
      this.status.focus({ preventScroll: true });
    }

    async submit(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.pending || this.completed || !this.form.reportValidity()) return;
      const variantId = this.dataset.variantId;
      if (!/^[0-9]+$/.test(variantId || '')) {
        this.showStatus(false);
        return;
      }
      const formData = new FormData(this.form);
      const email = String(formData.get('contact[email]') || '').trim();
      if (!email) return;
      this.pending = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.form.setAttribute('aria-busy', 'true');
      this.statusWrapper.hidden = true;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 15000);
      try {
        const properties = {};
        const name = String(formData.get('contact[name]') || '').trim();
        const phone = String(formData.get('contact[phone]') || '').trim();
        if (name) properties.back_in_stock_contact_name = name;
        if (phone) properties.back_in_stock_contact_phone = phone;
        if (Object.keys(properties).length) {
          await this.post('profiles', { type: 'profile', attributes: { email, properties } });
        }
        await this.post('back-in-stock-subscriptions', {
          type: 'back-in-stock-subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email } } }, channels: ['EMAIL'] },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
        });
        this.completed = true;
        this.form.reset();
        this.showStatus(true);
      } catch (error) {
        console.warn('RedSeven stock alert request failed:', error.name, error.message);
        if (this.isConnected) this.showStatus(false);
      } finally {
        clearTimeout(timeout);
        this.pending = false;
        this.form.removeAttribute('aria-busy');
        this.button.removeAttribute('aria-busy');
        this.button.disabled = Boolean(this.completed);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
